import { NavLink, useNavigate } from 'react-router-dom'
import { ChartNoAxesColumn, House, Plus, User, type LucideIcon } from 'lucide-react'
import { ICON_STROKE } from '../lib/icons.js'
import { useT } from '../lib/useT.js'

const tabs: Array<{ to: string; key: string; icon: LucideIcon; end: boolean }> = [
  { to: '/', key: 'nav.home', icon: House, end: true },
  { to: '/history', key: 'nav.history', icon: ChartNoAxesColumn, end: false },
  { to: '/profile', key: 'nav.profile', icon: User, end: false },
]

/**
 * Barre flottante : une pilule sombre pour la navigation, et à côté le bouton
 * d'action principale. Il vit ici — hors de toute zone défilante et sous le
 * pouce — plutôt que dans un pied d'écran qui mangeait la hauteur utile.
 */
export function TabBar() {
  const t = useT()
  const navigate = useNavigate()
  return (
    <div className="safe-bottom relative flex items-center gap-3 px-5 pt-2">
      {/* Le contenu s'estompe sous la barre au lieu d'être coupé net. */}
      <div
        className="from-canvas pointer-events-none absolute inset-x-0 -top-6 h-6 bg-gradient-to-t to-transparent"
        aria-hidden="true"
      />
      <nav className="bg-night flex-1 rounded-full p-1.5 shadow-[var(--shadow-float)]">
        <ul className="flex items-center justify-between">
          {tabs.map(({ to, key, icon: Icon, end }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={end}
                // L'onglet actif s'élargit et affiche son nom ; les autres
                // restent des icônes, nommées pour le lecteur d'écran.
                className={({ isActive }) =>
                  `text-caption flex h-12 items-center justify-center gap-2 rounded-full font-bold transition-colors duration-150 ${
                    isActive ? 'bg-surface text-ink px-5' : 'text-surface/70 w-12'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    <Icon size={20} strokeWidth={ICON_STROKE} aria-hidden="true" />
                    <span className={isActive ? '' : 'sr-only'}>{t(key)}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <button
        onClick={() => navigate('/log')}
        aria-label={t('home.logActivity')}
        className="press bg-accent text-ink grid size-15 shrink-0 place-items-center rounded-full shadow-[var(--shadow-float)]"
      >
        <Plus size={26} strokeWidth={2.5} aria-hidden="true" />
      </button>
    </div>
  )
}
